<template>
  <!-- MD-2/MD-3 (MD-K1): «Yeni X» düğmesi. Masaüstünde yerinde (sarmalayıcı display:contents),
       dar ekranda body'ye taşınıp sağ altta 56 px yuvarlak düğme (FAB) olur. Sayfada tek FAB:
       sekme içindeki bileşenlerde kullanılmaz (gizli sekmeler de FAB çizerdi). -->
  <Teleport to="body" :disabled="!ekran.dar">
    <div :class="ekran.dar ? ['md-fab', { 'md-fab-cubuklu': cubuklu, 'md-yukari': surum.goster }] : 'contents'">
      <slot />
    </div>
  </Teleport>
</template>

<script>
import { darEkranDurum } from "@/services/darEkran";
import { yeniSurumState } from "@/services/yeniSurum";

export default {
  name: "YeniDugme",
  props: {
    // Sayfada alt eylem çubuğu (SayfaBasligi #birincil) da varsa FAB onun üstünde durur.
    cubuklu: { type: Boolean, default: false },
  },
  data() {
    return { ekran: darEkranDurum, surum: yeniSurumState };
  },
};
</script>

<style>
/* Scoped değil: slot içeriği (sayfanın Button'u) başka bileşenin kapsamında. !important:
   Tailwind important:true, sayfanın px-4/rounded-lg/mr-1 sınıflarını ezer. Düğme metni
   font-size 0 ile görsel olarak gizlenir, erişilebilir ad olarak kalır. Sparqon paneli
   (z 1000, dar ekranda tam ekran) açıkken FAB'ı örter. */
.md-fab {
  position: fixed;
  right: 16px;
  bottom: calc(16px + env(safe-area-inset-bottom, 0px));
  z-index: 900;
}
.md-fab.md-fab-cubuklu {
  bottom: calc(80px + env(safe-area-inset-bottom, 0px));
}
.md-fab.md-yukari {
  bottom: calc(96px + env(safe-area-inset-bottom, 0px));
}
.md-fab .p-button {
  width: 56px !important;
  height: 56px !important;
  padding: 0 !important;
  border-radius: 9999px !important;
  font-size: 0 !important;
  justify-content: center !important;
  box-shadow: 0 4px 12px rgb(0 0 0 / 0.25) !important;
}
.md-fab .p-button .pi {
  font-size: 1.5rem !important;
  margin: 0 !important;
}
.md-fab .p-button .p-button-label {
  font-size: 0 !important;
}
</style>
